<template>
  <transition name="fade">
    <div class="modal show" style="display: block;">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <div class="v2__heading">Landing Page Setup</div>
            <div class="btn-close-wrapper" @click.stop="closeModal">
              <span class="material-icons">close</span>
            </div>
          </div>
          <div class="modal-body">
            <div style="margin-bottom: 1rem;">Before you can use Landing Pages, we need some information about your account.</div>
            <el-form ref="details" :rules="rules" :model="setup" status-icon>
              <el-form-item prop="url">
                <label for="url">Website URL</label>
                <el-input type="text" id="url" v-model.trim="setup.url" placeholder="URL" />
              </el-form-item>
              <el-form-item prop="subdomain">
                <label for="subdomain">Subdomain</label>
                <input class="domain-input" type="text" id="subdomain" v-model.trim="setup.subdomain"  placeholder="Subdomain" @input="setup.subdomain=$event.target.value.toLowerCase()"/>
                <div class="display-caption subdued">Your subdomain will be used to create your Landing Pages URLs. Your URLs will be in the format of <b>https://{{ setup.subdomain ? setup.subdomain : 'subdomain' }}.brandbot-checkout.com</b>. This is unique, lowercased and not editable once set.</div>
              </el-form-item>
              <el-form-item prop="waiver">
                <label for="waiver">Liability Waiver</label>
                <el-input type="textarea" :rows="3" v-model.trim="setup.waiver" placeholder="Liability Waiver" />
                <div class="display-caption subdued">Your waiver is used when your leads are creating a new account.</div>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" class="xpl-button xpl-button--primary" @click.stop="saveDetails" :loading="loading">Save</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
  import * as api from '@/api';

  export default {
    props: ['account'],
    data() {
      const checkVanity = (rule, value, callback) => {
        if (!value) {
          return callback(new Error('A valid subdomain is required for your Landing Pages.'));
        }

        if (!value.match(/^[0-9a-zA-Z-_]+$/)) {
          return callback(new Error('Only alphanumeric characters, "-" and "_" are allowed.'));
        }

        return callback();
      };
      const checkUrl = (rule, value, callback) => {
        if (value &&
          !value.match(/^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([-.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/gm)) {
          return callback(new Error('We need a valid url for your website.'));
        }

        return callback();
      };
      return {
        loading: false,
        setup: {
          subdomain: JSON.parse(this.account.metadata).subdomain,
          url: this.account.website_url,
          waiver: this.account.liability_waiver,
          currency: this.account.currency,
        },
        rules: {
          subdomain: [{ validator: checkVanity, trigger: 'change' }],
          url: [{ validator: checkUrl, trigger: 'change' }],
          waiver: [{ required: true, trigger: 'change', message: 'We need a Liability Waiver.' }],
        },
      };
    },
    methods: {
      closeModal() {
        this.$router.push('/apps/');
      },
      saveDetails() {
        this.$refs.details.validate((valid) => {
          if (!valid) {
            return;
          }

          this.loading = true;

          const payload = {
            website_url: this.setup.url,
            subdomain: this.setup.subdomain,
            liability_waiver: this.setup.waiver,
            currency: this.setup.currency,
          };

          api.updateAccount(this.account.id, payload).then((response) => {
            this.loading = false;
            this.$message.success(response.message);
            location.reload();
          }).catch((err) => {
            this.loading = false;
            this.$message.error(err.message);
          });
        });
      },
    },
  };
</script>
<style lang="scss" scoped>
  .modal .modal-body {
    max-height: 90vh;
    overflow-y: scroll;
  }

  .display-caption {
    line-height: 1.25rem;
  }

  .domain-input {
    border-radius: 6px;
    -webkit-appearance: none;
    background-color: #FFFFFF;
    background-image: none;
    border: 1px solid #DCDFE6;
    box-sizing: border-box;
    color: #606266;
    display: inline-block;
    font-size: inherit;
    height: 40px;
    line-height: 40px;
    outline: none;
    padding: 0 15px;
    transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
    width: 100%;
   
    &:hover {
      border-color: #C0C4CC;
    }

    &:focus {
      outline: none;
      border-color: #6923f4;
    }
  }
</style>
